export const SIMPLE_RANK_DISPLAY = "SIMPLE_RANK_DISPLAY";
export const CONTESTANT_DETAILS_DISPLAY = "CONTESTANT_DETAILS_DISPLAY";
